export const getDateStringFromDate = (date: string | Date): string => {
  return (date instanceof Date
    ? date
    : new Date(parseInt(date))
  ).toLocaleDateString("fr-FR", {});
};
